<template>
    <div class="contact" :class="$mq">
        <CTABanner />
        <section class="container">
            <ContactForm v-animate="'fade-in'" />
        </section>
    </div>
</template>

<script>
import CTABanner from '@/components/Banner/CTABanner.vue'
import ContactForm from '@/components/Form/ContactForm.vue'

export default {
    name: "Contact",
    
    components: {
        CTABanner,
        ContactForm
    }
}
</script>

<style lang="scss" scoped>
</style>